import { Observable, Subscription } from 'rxjs';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { ConfirmService, Pagination } from '@app/shared/common';
import { Paginator } from 'primeng/paginator';
import { AuthService } from '@app/core/authentication';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styles: [
    `
      .w-btn-group {
        margin: auto;
      }
      ::ng-deep {
        .rating-stars {
          min-width: 80px;
        }
      }
    `,
  ],
})
export class TableComponent implements OnInit, OnDestroy {
  /**
   * @description
   * Data display table
   */

  /**
   * * General
   * @numberOfCols Calc number of cals and set that as colspan for generic message when table is empty
   */
  subscriptions: Subscription[] = [];
  numberOfCols: number;
  /**
   * * Outputs
   * @handlePageChange Event when page in paginator is changed
   * @handleStatusChange Event when post/page status is changed
   * (Status indicates whether the page is visible on the site or not)
   * @handleDelete Event when row in table is deleted
   */
  @Output() handlePageChange = new EventEmitter<any>();
  @Output() handleStatusChange = new EventEmitter<any>();
  @Output() handleDelete = new EventEmitter<any>();
  @Output() handlePreview = new EventEmitter<any>();
  @Output() handleSelect = new EventEmitter<any>();
  /**
   * * Inputs
   * @loading Set table spinner
   * @tableHeader Array of table headers ['name', 'surname']
   * @tableData Actual table data
   * @editPath Determines how url path for edit shoud look: /#/edit/23
   * @options Additional table options
   */
  @Input() rowsPerPage;
  @Input() actionLabel = 'Actions';
  @Input() resetSelected: Observable<void>;
  @Input() paginator: Pagination | any;
  @Input() frontendPaginator = false;
  @Input() loading = false;
  @Input() enableRowSelect = false;
  @Input() tableHeader: any[];
  @Input() tableData: any;
  @Input() editPath: 'edit' | 'post_template' | 'page-builder' = 'edit';
  @Input() customOptions = [];
  @Input() options: {
    showPreview?: boolean;
    showEdit?: boolean;
    showDelete?: boolean;
    showStatus?: boolean;
    showSwitch?: boolean;
    showClone?: boolean;
    switchText?: string;
  } = {
    showPreview: false,
    showEdit: false,
    showDelete: false,
    showStatus: false,
    showSwitch: false,
    showClone: false,
    switchText: 'Rešen',
  };
  selectedRows;
  curentUser;
  @ViewChild('paginatorElement') paginatorElement: Paginator;

  constructor(
    private confirmService: ConfirmService,
    private authService: AuthService
  ) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    this.curentUser = this.authService.userValue;

    /**
     * Calc number of cols
     */
    this.numberOfCols =
      this.tableHeader.length +
      ((this.options.showDelete && this.options.showEdit) ||
      this.options.showPreview
        ? 1
        : 0) +
      (this.options.showSwitch ? 1 : 0);

    if (this.resetSelected) {
      this.subscriptions.push(
        this.resetSelected.subscribe((res) => {
          this.selectedRows = [];
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  private updateCurrentPage(currentPage: number): void {
    this.paginatorElement.changePage(currentPage - 1);
  }

  onPageChange(event: any) {
    this.handlePageChange.emit(event);
  }

  onChangeStatus(event: any, id: number) {
    this.handleStatusChange.emit({ event, id });
  }

  deleteRow(event: Event, id: number) {
    this.confirmService.confirm(event, {
      accept: () => {
        this.handleDelete.emit({ event, id });
        if (this.paginator) this.paginatorElement.changePageToFirst(event);
      },
    });
  }

  onRowSelect() {
    console.log('Selektuj red', this.selectedRows);
    this.handleSelect.emit(this.selectedRows);
  }
  onSelectAll() {
    console.log('Selektuj SVE', this.selectedRows);
  }

  previewRow(event: Event, data: any) {
    this.handlePreview.emit({ event, data });
  }
}
